import axios from 'axios';
import React from 'react'
import { useState } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { API_URL } from '../../const/api';
import { PRIMARY, SECONDARY } from '../../const/colors';
import { selectCurrency, selectId, selectToken, setNewToken } from '../../features/user/userSlice';
import { useWithdraw } from '../../hooks/useWithdraw';
import { Buttonpin, MainViewContainerWithdraw, NoMethodSelected } from './DepositElements';
import FormAstroPay from './formRetiro/FormAstroPay';
import FormPay4Fun from './formRetiro/FormPay4Fun';
import FormWithdraw from './formRetiro/FormWithdraw';
import { ReactComponent as DepositLogo } from '../../assets/images/logos/RETIRO-main.svg';
import FormPayRetailers from './formRetiro/FormPayRetailer';
import FormTuPay from './formRetiro/FormTuPay';
import FormMonnet from './formRetiro/FormMonnet';
import FormMonnetPeru from './formRetiro/FormMonnetPeru';
import FormPagoFacil from './formRetiro/FormPagoFacil';
import FormCoinspaidRetiro from "./formRetiro/FormCoinspaidRetiro";
import FormBinanceUSD from "./formRetiro/FormBinanceUSD";
import FormPix from "./formRetiro/FormPix";
import FormSpei from "./formRetiro/FormSpei";
import FormAlps from "./formRetiro/FormAlps";
import FormKushkiRetiro from "./formRetiro/FormKushkiRetiro";
import FormMibanco from "./formRetiro/FormMibanco";
import FormTransPYG from "./formRetiro/FormTransPYG";
import FormBDV from "./formRetiro/FormBDV";

const MainViewWithdraw = ({withdrawMethod, handleExit}) => {
  const [t] = useTranslation('global')
  const dispatch = useDispatch();
  const id_uo = useSelector(selectId);
  const moneda = useSelector(selectCurrency);
  const token = useSelector(selectToken);
  const restrictedCurrencies = ['ARS', 'DOP', 'MXN', 'BRL', 'CLP', 'EUR', 'BOB', 'GTQ', 'PYG'];

  const [cuentas, setCuentas] = useState([]);

  useEffect(() => {
    const loadData = async () => {
      const body = { id_uo, token, moneda };
      const res = await axios.post(API_URL + "loadDatosRetiro", body);
      dispatch(setNewToken(res.data.token));
      if (res.data.status === 1) {
        if (typeof res.data.response === "string") {
          setCuentas([]);
        } else {
          setCuentas(res.data.response);
        }
      }
    };
    loadData();
  }, []);

  const showPin = async () => {
    const body = { id_uo, token };
    const res = await axios.post(API_URL + "loadPinRetiro", body);
    if (res.data.status === 1) {
      dispatch(setNewToken(res.data.token));
      Swal.fire({
        title: `PIN: ${res.data.response}`,
        text: "",
        icon: "info",
        background: SECONDARY,
        color: "#fff",
        confirmButtonColor: PRIMARY,
      });
    } else {
      dispatch(setNewToken(res.data.token));
    }
  };

    //HOOKS
    const {
      loading,
      form,
      setForm,
      clearForm,
      formAstroPay,
      formPay4Fun,
      formPayRetailer,
      formTuPay,
      formMonnet,
      formMonnetperu,
      formPagoFacil,
      formCoinspaidRetiro,
      formBinanceUSD,
      formPix,
      formSpei,
      formAlps,
      formKushkiRetiro,
      formMibanco,
      formTransPYG,
      formBDV,
      bancoTipo,
      handleChangePay4Fun,
      handleBanco,
      handleChangePayRetailer,
      handleChangeTuPay,
      handleChangeMonnet,
      handleChangeMonnetperu,
      handleChangePagoFacil,
      handleChangeCoinspaidRetiro,
      handleChangeBinanceUSD,
      handleChangePix,
      handleChangeSpei,
      handleChangeAlps,
      handleChangeKushkiRetiro,
      handleChangeMibanco,
      handleChangeTransPYG,
      handleChangeBDV,
      solicitarRetiro,
      solicitarRetiroRetailer,
      solicitarRetiroAstroPay,
      solicitarRetiroPayRetailer,
      solicitarRetiroTuPay,
      solicitarRetiroMonnet,
      solicitarRetiroMonnetperu,
      solicitarRetiroPagoFacil,
      solicitarRetiroCoinspaid,
      solicitarRetiroBinanceUSD,
      solicitarRetiroPix,
      solicitarRetiroSpei,
      solicitarRetiroAlps,
      solicitarRetiroKushkiRetiro,
      solicitarRetiroMibanco,
      solicitarRetiroTransPYG,
      solicitarRetiroBDV,
      handleChange,
      handleChangeAstroPay,
    } = useWithdraw();

  return (
    withdrawMethod ? (
      <MainViewContainerWithdraw>
        {withdrawMethod === "retiro" && (
          <FormWithdraw
            bancoTipo={bancoTipo}
            handleBanco={handleBanco}
            cuentas={cuentas}
            moneda={moneda}
            form={form}
            setForm={setForm}
            handleChange={handleChange}
            clearForm={clearForm}
            handleClose={handleExit}
            solicitarRetiro={solicitarRetiro}
            loading={loading}
          />
        )}
        {withdrawMethod === "pay4fun" && (
          <FormPay4Fun
            form={formPay4Fun}
            handleChange={handleChangePay4Fun}
            handleClose={handleExit}
            solicitarRetiro={solicitarRetiroRetailer}
            loading={loading}
          />
        )}
        {withdrawMethod === "astropay" && (
          <FormAstroPay
            form={formAstroPay}
            handleChange={handleChangeAstroPay}
            handleClose={handleExit}
            solicitarRetiro={solicitarRetiroAstroPay}
            loading={loading}
          />
        )}
        {withdrawMethod === "payretailer" && (
          <FormPayRetailers
            form={formPayRetailer}
            handleChange={handleChangePayRetailer}
            handleClose={handleExit}
            solicitarRetiro={solicitarRetiroPayRetailer}
            loading={loading}
          />
        )}

        {withdrawMethod === "tupay" && (
          <FormTuPay
            form={formTuPay}
            handleChange={handleChangeTuPay}
            handleClose={handleExit}
            solicitarRetiro={solicitarRetiroTuPay}
            loading={loading}
          />
        )}

        {withdrawMethod === "monnet" && (
          <FormMonnet
            form={formMonnet}
            handleChange={handleChangeMonnet}
            handleClose={handleExit}
            solicitarRetiro={solicitarRetiroMonnet}
            loading={loading}
          />
        )}
        {withdrawMethod === "monnetperu" && (
          <FormMonnetPeru
            form={formMonnetperu}
            handleChange={handleChangeMonnetperu}
            handleClose={handleExit}
            solicitarRetiro={solicitarRetiroMonnetperu}
            loading={loading}
          />
        )}
        {withdrawMethod === "pagofacil" && (
          <FormPagoFacil
            form={formPagoFacil}
            handleChange={handleChangePagoFacil}
            handleClose={handleExit}
            solicitarRetiro={solicitarRetiroPagoFacil}
            loading={loading}
          />
        )}
        {withdrawMethod === "CoinspaidRetiro" && (
          <FormCoinspaidRetiro
            form={formCoinspaidRetiro}
            handleChange={handleChangeCoinspaidRetiro}
            handleClose={handleExit}
            solicitarRetiro={solicitarRetiroCoinspaid}
            loading={loading}
          />
        )}
        {withdrawMethod === "binanceUSD" && (
          <FormBinanceUSD
            form={formBinanceUSD}
            handleChange={handleChangeBinanceUSD}
            handleClose={handleExit}
            solicitarRetiro={solicitarRetiroBinanceUSD}
            loading={loading}
          />
        )}
        {withdrawMethod === "Pix" && (
          <FormPix
            form={formPix}
            handleChange={handleChangePix}
            handleClose={handleExit}
            solicitarRetiro={solicitarRetiroPix}
            loading={loading}
          />
        )}
        {withdrawMethod === "Spei" && (
          <FormSpei
            form={formSpei}
            handleChange={handleChangeSpei}
            handleClose={handleExit}
            solicitarRetiro={solicitarRetiroSpei}
            loading={loading}
          />
        )}
        {withdrawMethod === "Alps" && (
          <FormAlps
            form={formAlps}
            handleChange={handleChangeAlps}
            handleClose={handleExit}
            solicitarRetiro={solicitarRetiroAlps}
            loading={loading}
          />
        )}

        {withdrawMethod === "Kushki" && (
          <FormKushkiRetiro
            form={formKushkiRetiro}
            handleChange={handleChangeKushkiRetiro}
            handleClose={handleExit}
            solicitarRetiro={solicitarRetiroKushkiRetiro}
            loading={loading}
          />
        )}

        {withdrawMethod === "mibanco" && (
          <FormMibanco
            form={formMibanco}
            handleChange={handleChangeMibanco}
            handleClose={handleExit}
            solicitarRetiro={solicitarRetiroMibanco}
            loading={loading}
          />
        )}

        {withdrawMethod === "astropayCH" && (
          <FormAstroPay
            form={formAstroPay}
            handleChange={handleChangeAstroPay}
            handleClose={handleExit}
            solicitarRetiro={solicitarRetiroAstroPay}
            loading={loading}
          />
        )}

        {withdrawMethod === "astropayARG" && (
          <FormAstroPay
            form={formAstroPay}
            handleChange={handleChangeAstroPay}
            handleClose={handleExit}
            solicitarRetiro={solicitarRetiroAstroPay}
            loading={loading}
          />
        )}

        {withdrawMethod === "astropayCO" && (
          <FormAstroPay
            form={formAstroPay}
            handleChange={handleChangeAstroPay}
            handleClose={handleExit}
            solicitarRetiro={solicitarRetiroAstroPay}
            loading={loading}
          />
        )}

        {withdrawMethod === "PYGRetiro" && (
          <FormTransPYG
            form={formTransPYG}
            handleChange={handleChangeTransPYG}
            handleClose={handleExit}
            solicitarRetiro={solicitarRetiroTransPYG}
            loading={loading}
          />
        )}

        {withdrawMethod === "BDVretiro" && (
          <FormBDV
            form={formBDV}
            handleChange={handleChangeBDV}
            handleClose={handleExit}
            solicitarRetiro={solicitarRetiroBDV}
            loading={loading}
          />
        )}
        
      </MainViewContainerWithdraw>
    ) : 
    <NoMethodSelected>
    {/*  <DepositLogo style={{fill:'black'}} />
     <p>{t("deposit.select-payment-method-withdraw")}</p> */}
      {!restrictedCurrencies.includes(moneda) && (
       <Buttonpin primary={true} onClick={showPin} style={{maxWidth:'200px'}}>
          {t('withdraw.lbl-pin')}
        </Buttonpin>
      )}
    </NoMethodSelected>
  )
}

export default MainViewWithdraw